/**
 * Husleie.no API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0
 * Contact: devops+api@husleie.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import InlineObject16 from '../model/InlineObject16';
import InlineObject17 from '../model/InlineObject17';
import InlineObject18 from '../model/InlineObject18';
import InlineResponse20019 from '../model/InlineResponse20019';
import InlineResponse20020 from '../model/InlineResponse20020';
import InlineResponse20021 from '../model/InlineResponse20021';
import InlineResponse401 from '../model/InlineResponse401';
import InlineResponse4011 from '../model/InlineResponse4011';

/**
 * Signup service.
 * @module api/SignupApi
 * @version 1.0
 */
export default class SignupApi {

    /**
     * Constructs a new SignupApi. 
     * @alias module:api/SignupApi
     * @class
     * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
     * default to {@link module:ApiClient#instance} if unspecified.
     */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the signup operation.
     * @callback module:api/SignupApi~signupCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse20019} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Signing up to use the service
     * If successfull, this will return a token to access the API as the user, and the created IDs
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject16} opts.body 
     * @param {module:api/SignupApi~signupCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse20019}
     */
    signup(opts, callback) {
        opts = opts || {};
        let postBody = opts['body'];


        let pathParams = {};
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse20019;

        return this.apiClient.callApi(
            '/signup', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the verifyCellPhoneSend operation.
     * @callback module:api/SignupApi~verifyCellPhoneSendCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse20020} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Send a SMS verification code
     * Send a SMS to the provided phone number and return a verification token
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject17} opts.body 
     * @param {module:api/SignupApi~verifyCellPhoneSendCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse20020}
     */
    verifyCellPhoneSend(opts, callback) {
        opts = opts || {};
        let postBody = opts['body'];


        let pathParams = {};
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse20020;

        return this.apiClient.callApi(
            '/signup/verify_cell_phone/send', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the verifyCellPhoneVerify operation.
     * @callback module:api/SignupApi~verifyCellPhoneVerifyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse20021} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Send a SMS verification code
     * Send a SMS to the provided phone number and return a verification token
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject18} opts.body 
     * @param {module:api/SignupApi~verifyCellPhoneVerifyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse20021}
     */
    verifyCellPhoneVerify(opts, callback) {
        opts = opts || {};
        let postBody = opts['body'];


        let pathParams = {};
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse20021;

        return this.apiClient.callApi(
            '/signup/verify_cell_phone/verify', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }


}